<template>
  <div>
    <b-modal
      ref="modalDispensarCertificados"
      :title="'Dispensa automática de certificados'"
      size="lg"
      no-close-on-backdrop
      :title-class="'font-modal'"
      :dialog-class="'alteracao-tamanho'"
      :modal-class="'center-modal'"
      @show="carregarPropostas"
      @hidden="fechadoModal"
    >
      <vue-good-table
        :columns="columns"
        :rows="rows"
        theme="view"
        max-height="300px"
        :fixed-header="true"
        :row-style-class="'style-dados'"
        style-class="vgt-table striped bordered"
      >
        <template
          slot="table-row"
          slot-scope="props"
        >
          <b-checkbox
            v-if="props.column.field === 'check'"
            v-model="props.row.check"
            :disabled="props.row.atual"
            :checked="props.row.atual"
            :class="[{ 'check-desabilitado': props.row.atual }]"
            @change="checkboxClicked(props.row)"
          />
          <div>
            <span
              v-if="props.column.field === 'nome'"
            >
              {{ props.row.nome }}
            </span>
            <span
              v-if="props.column.field === 'vencimento'"
              style="text: center"
            >
              {{ props.row.vencimento }}
            </span>
          </div>
        </template>
        <div slot="emptystate">
          {{ mensagem }}
        </div>
      </vue-good-table>

      <b-row
        class="mt-2"
        align-h="between"
      >
        <b-col cols="6">
          <span
            v-if="!todosSelecionados"
            class="selecao-todas"
            @click="selecionarTodas(true)"
          >
            Selecionar todos "clique aqui"
          </span>
          <span
            v-if="todosSelecionados"
            class="selecao-todas"
            @click="selecionarTodas(false)"
          >
            Limpar seleção "clique aqui"
          </span>
        </b-col>
        <b-col
          cols="6"
          style="text-align: end"
        >
          <span style="font-weight: bold;font-size:14px;">Certificados selecionados: {{ totalSelecionado }}</span>
        </b-col>
      </b-row>

      <template #modal-footer>
        <b-btn
          variant="success"
          size="sm"
          @click="enviar"
        >
          Confirmar
        </b-btn>
      </template>
    </b-modal>
  </div>
</template>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";

.style-dados {
  font-size: 14px;
  color: red
}

.font-modal {
  font-size: 18px;
}

.alteracao-tamanho {
  width: 1400px !important;
}

.center-modal {
  display: flex !important;
  justify-content: center !important;
}

.check-desabilitado {
  opacity: 0.6;
}

.selecao-todas {
  text-decoration: underline;
  color: var(--primary);
  cursor: pointer;
}

.proposta-nao-aprovada {
  color: red;
}
</style>

<script>
import { VueGoodTable } from 'vue-good-table'

export default {
  name: 'PropostasAgrupadas',
  components: {
    VueGoodTable,
  },
  props: {
    certificados: {
      type: Array,
      default: () => [],
    },
    mensagem: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      columns: [
        {
          label: 'Ação',
          field: 'check',
          thClass: 'style-dados',
          sortable: false,
        },
        {
          label: 'Nome certificado',
          field: 'nome',
          thClass: 'style-dados',
        },
        {
          label: 'Vencimento',
          field: 'vencimento',
          thClass: 'style-dados',
        },
      ],
      rows: [],
      certificadosSelecionados: [],
      isCarregando: false,
      todosSelecionados: false,
    }
  },
  computed: {
    totalSelecionado() {
      return this.certificadosSelecionados.length
    },
  },
  watch: {
    certificados(value, oldValue) {
      if (value !== oldValue) {
        this.carregarPropostas()
      }
    },
  },
  methods: {
    carregarPropostas() {
      this.rows = this.certificados
      this.isCarregando = false
      this.rows[0].check = true
      if (this.certificadosSelecionados.length === 0) {
        this.certificadosSelecionados.push(this.rows[0])
      }
    },
    fechadoModal() {
      this.certificadosSelecionados = []
      this.rows = []
      this.todosSelecionados = false
    },
    enviar() {
      const certificadoIds = this.certificadosSelecionados.map(map => map.id)
      this.$emit('salvar-certificado', certificadoIds)
    },
    checkboxClicked(prop) {
      if (!this.certificadosSelecionados.some(som => som.id === prop.id)) {
        this.certificadosSelecionados.push(prop)
        this.todosSelecionados = this.certificadosSelecionados.length === this.rows.length
      } else {
        const index = this.certificadosSelecionados.findIndex(find => find.id === prop.id)
        if (index > -1) {
          this.certificadosSelecionados.splice(index, 1)
        }
      }
    },
    selecionarTodas(value) {
      this.todosSelecionados = value
      this.linhas = []
      this.rows.forEach(element => {
        const e = element
        if (!e.atual) {
          e.check = value
        }
        this.linhas.push(e)
      })
      this.rows = this.linhas
      this.certificadosSelecionados = this.rows.filter(fil => fil.check)
    },
  },
}
</script>
